module.exports = __webpack_public_path__ + "static/media/PublicisOne.c0ecefdb.png";